import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import threadDefault from '../images/Default-Threads.jpg';
import {GetOptimizeImage } from '../utils/handle-session';
export default function PersonaliseData({data}) {
	
	const myLoader = ({src}) => {
		return `${src}`;
	};
	return (
		data.attributes.bits_categories.data!==null &&
		data.attributes.bits_categories.data.map((d,index)=>{
			if(d.id==13 || d.id==12 || d.id==19 || d.id==11){
				return false;
			}
          return <div key={index}  className="subject-list mb-9">
		  <div className="flex justify-between mb-6">
			  <h5 className="text-white font-medium md:text-2xl sm:text-xl text-base">{d.attributes.name}</h5>
			  <Link href={`/category/${d.attributes.slug}`}>
				  <a className="text-white sm:text-base text-sm">See All</a>
			  </Link>
		  </div>
		  <div className="flex flex-no-wrap overflow-x-scroll custom-x-scroll -mx-2">
			  {d.attributes.bits_threads.data !== null &&
				  d.attributes.bits_threads.data.map((thread, index) => {
					let Images=thread.attributes.image.data !=null ?GetOptimizeImage(thread.attributes.image.data.attributes):null;
					  return (
						  <div key={index} className="lg:w-1/4 md:w-1/4 w-1/2 px-2 flex-shrink-0">
							  <div className="rounded-xl mb-6 relative courser-list">
								 
									  <div className="card-img">
										  <Image
											  loader={myLoader}
											  src={Images ? `${Images}`:threadDefault}
											  width={156}
											  height={213}
											  alt=""
											  className="block rounded-xl loader-img"
										  />
									  </div>
								
								  <div className="absolute inset-0 bg-overly rounded-xl">
									  <Link href={`/threads/${thread.attributes.slug}`}>
										  <a>
											  <h4 className="font-semibold text-base text-white h-full flex items-end pb-3 px-2">{thread.attributes.title}</h4>
										  </a>
									  </Link>
								  </div>
							  </div>
						  </div>
					  );
				  })}
		  </div>
		  {/* <div className="flex flex-no-wrap overflow-x-scroll custom-x-scroll -mx-2">
			  {d.attributes.bits_contents.data !== null &&
				  d.attributes.bits_contents.data.map((bit, index) => {
					  return (
						  <div key={index} className="lg:w-1/4 md:w-1/4 w-1/2 px-2 flex-shrink-0">
							  <div className="rounded-xl mb-6 relative courser-list">
								  <div>
									  <Link href={`/bits/category/${bit.attributes.slug}?key=${index + 1}&kind=featured`}>
										  <a>
											  <video
												  loop
												  muted
												  autoPlay
												  style={{
													  width: '100%',
													  height: '100%',
												  }}
												  className="rounded-xl">
												  <source src={`${bit.attributes.video.data.attributes.url}`} type={bit.attributes.video.data.attributes.mime} />
											  </video>
										  </a>
									  </Link>
								  </div>
							  </div>
						  </div>
					  );
				  })}
		  </div> */}
	  </div>
		})
		
	);
}
